/** Local calendar day as YYYY-MM-DD; a string already in that shape passes through. */
export function toLocalDateString(value: Date | string | null | undefined): string | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
        return null;
    }
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
